/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createLoadingSelector, createErrorSelector, errorActions } from "@a1/core";
import { processActions } from "../../reducer/processReducer";

import logoSplash from "../../images/logo_splash.png";

const actionsNames = ["FORGOTTEN_PASS_CHECK_EMAIL"];

class ForgottenPass extends Component {
  state = {
    email: "",
    emailError: "",
    mustValidateData: false,
  };

  componentDidMount() {
    document.title = "Забравена парола - A1 Xplore TV GO";

    const { process, clearErrors, forgottenPassResetResults } = this.props;

    clearErrors(actionsNames);

    if (process.forgottenPassCheckEmailResult) {
      forgottenPassResetResults();
    }

    this.handleAutofocus();
  }

  componentDidUpdate(prevProps) {
    const { history, loading, process, error } = this.props;

    if (
      !loading &&
      !(error && error.length) &&
      !(process.forgottenPassCheckEmailResult && process.forgottenPassCheckEmailResult.error)
    ) {
      // Typical usage (don't forget to compare props):
      if (
        process.forgottenPassCheckEmailResult &&
        process.forgottenPassCheckEmailResult !== prevProps.process.forgottenPassCheckEmailResult &&
        process.forgottenPassCheckEmailResult.isOk === true
      ) {
        history.push("/passrecovery-email");
        return false;
      }
    }

    this.handleAutofocus();
    return false;
  }

  handleInputChange = event => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    const { mustValidateData } = this.state;
    const { process, forgottenPassResetResults } = this.props;
    if (process.forgottenPassCheckEmailResult && process.forgottenPassCheckEmailResult.error) {
      forgottenPassResetResults();
    }

    this.setState({
      [name]: value,
    });

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleInputOnKeyUp = event => {
    const { mustValidateData } = this.state;

    if (event.keyCode === 13) {
      this.handleNextClick();
    }

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleAutofocus = () => {
    const autofocusElements = document.getElementsByClassName("autofocus");
    if (autofocusElements && autofocusElements.length > 0) {
      autofocusElements[0].focus();
    }
  };

  validateData = () => {
    const { email } = this.state;
    let isValid = false;

    if (email.length > 0) {
      const re = /^\S+@\S+\.\S+$/;
      if (re.test(email)) {
        isValid = true;
        this.setState({ emailError: "" });
      } else {
        this.setState({
          emailError:
            "Въведеният e-mail е грешен. Моля, въведи отново, като използваш само малки букви на латиница, без интервали.",
        });
      }
    } else {
      this.setState({
        emailError: "Въведи e-mail адрес, като използваш само малки букви на латиница, без интервали.",
      });
    }

    return isValid;
  };

  handleNextClick = () => {
    const { email, mustValidateData } = this.state;
    const { forgottenPassResetResults, forgottenPassSetEmail, forgottenPassCheckEmail } = this.props;

    forgottenPassResetResults();

    if (!mustValidateData) {
      this.setState({ mustValidateData: true });
    }

    if (this.validateData()) {
      forgottenPassSetEmail(email);
      forgottenPassCheckEmail(email);
    }
  };

  render() {
    const { email, emailError } = this.state;
    const { loading, error, process } = this.props;
    const requestError = error && error.length ? error.map(err => <p>{err}</p>) : null;

    let divError = null;

    if (requestError) divError = requestError;
    else if (emailError) divError = emailError;
    else if (process.forgottenPassCheckEmailResult && process.forgottenPassCheckEmailResult.error)
      divError = process.forgottenPassCheckEmailResult.error;

    divError = divError ? <div className="error">{divError}</div> : null;

    const divLoading = loading ? (
      <div className="loading">
        <div className="spinner-border" />
      </div>
    ) : null;

    return (
      <div className="page page-login">
        <div className="header-bg" />

        <div className="container container--small">
          {divLoading}

          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>
          <div className="container-body">
            <h1 className="tag-title">Забравена парола</h1>
            <div className="tag-content" style={{ margin: "-36px 0 50px 0", lineHeight: 1.2 }}>
              <small>
                Моля въведи e-mail адрес за вход в приложението A1 Xplore TV.
                <br />
                Използвай само малки букви на латиница, без интервали.
                <br />
              </small>
            </div>

            <div className="tag-textfield">
              <input
                type="text"
                name="email"
                id="email"
                className="autofocus tag-input"
                value={email}
                onChange={this.handleInputChange}
                onKeyUp={this.handleInputOnKeyUp}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
              />
              <label htmlFor="email">E-mail адрес</label>
            </div>

            {divError}

            <div className="tag-content" style={{ marginTop: "80px" }}>
              <button
                type="button"
                className="tag-btn tag-btn--active"
                onClick={this.handleNextClick}
                disabled={!!loading}
              >
                Продължи
              </button>
            </div>

            <div className="tag-content tag-content__help">
              Имаш въпроси?{" "}
              <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
                Помощ
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
    loading: createLoadingSelector(actionsNames)(state),
    error: createErrorSelector(actionsNames)(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearErrors: actions => dispatch(errorActions.clearErrors(actions)),
    forgottenPassResetResults: () => dispatch(processActions.forgottenPassResetResults()),
    forgottenPassSetEmail: email => dispatch(processActions.forgottenPassSetEmail(email)),
    forgottenPassCheckEmail: email => dispatch(processActions.forgottenPassCheckEmail(email)),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ForgottenPass);
